<template>
  <tbody>
    <tr>
      <td colspan="9" style="padding: 0" class="td-container">
        <table
          v-for="(itemChild, indexChild) in nodes.children"
          :key="indexChild"
        >
          <tr class="trr">
            <td style="text-align: left; width: 252px">
              <div
                class="tr-cont ellipsis"
                :style="{ paddingLeft: itemChild.lev? '20px' : '40px' }"
              >
               <span v-if="itemChild.lev">
                 <i
                  class="el-icon-caret-bottom"
                  style="color: #c0c4cc"
                  v-if="itemChild.flag"
                ></i>
                <i
                  class="el-icon-caret-right"
                  style="color: #c0c4cc"
                  v-else
                ></i>
               </span>
                <el-checkbox
                  v-model="itemChild.flag"
                  style="margin-left: 4px"
                ></el-checkbox>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="itemChild.name"
                  placement="top"
                >
                  <span style="margin-left: 12px">
                    {{ itemChild.name }}
                  </span>
                </el-tooltip>
              </div>
            </td>
            <td style="width:200px">{{ itemChild.item_count }}</td>
            <td>
              <el-tag v-if="itemChild.status" type="success">已发布</el-tag>
              <el-tag v-if="!itemChild.status" type="warning">未发布</el-tag>
            </td>
            <td>
              <el-tag v-if="itemChild.trial" type="success">可试用</el-tag>
              <el-tag v-if="!itemChild.trial" type="warning">不可试用</el-tag>
            </td>
            <td colspan="3"></td>
          </tr>

          <tr v-if="itemChild.children && itemChild.flag">
            <td colspan="7" style="padding: 0">
              <table style="border: none">
                <RecursiveComponent :nodes="itemChild"></RecursiveComponent>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: "RecursiveComponent",

  props: ["nodes"],
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
  border-bottom: 1px solid #ebeef5;
}

td {
  padding: 8px 8px;
  text-align: center;
  vertical-align: middle;
}

.td-container > table:last-child {
  border: none;
}

.trr {
  border-bottom: 1px solid #ebeef5;
}
.trr:last-child {
  border: none;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>